import { XIcon, StickyNoteIcon, LinkIcon, SparklesIcon } from 'lucide-react'
import { Button } from '@/components/ui/shadcn/button'

// Lightweight first-run tutorial for the onboarding canvas. A single dismissible
// welcome card (not full coachmarks) — see docs/design/onboarding-moodboard.md.
// Open state lives in useOnboardingTutorial (the page needs it too). Shown only in
// onboarding mode; the canvas renders it conditionally.
export function OnboardingCanvasTutorial({ onDismiss }: { onDismiss: () => void }) {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-24 z-30 flex justify-center px-4">
      <div className="bg-card border-border pointer-events-auto relative w-full max-w-md rounded-xl border p-5 shadow-lg">
        <button
          onClick={onDismiss}
          className="text-muted-foreground hover:text-foreground absolute right-3 top-3"
          aria-label="Dismiss tutorial">
          <XIcon size={16} />
        </button>
        <h2 className="text-foreground text-base font-semibold">This is your moodboard</h2>
        <p className="text-muted-foreground mt-1 text-sm">
          Everything you drop here teaches CASSI how your brand looks and sounds. Add as much or as
          little as you like.
        </p>
        <ul className="mt-4 flex flex-col gap-3">
          <li className="flex items-start gap-3">
            <StickyNoteIcon size={18} className="text-primary mt-0.5 shrink-0" />
            <span className="text-foreground text-sm">
              Write <span className="font-medium">notes</span> about your voice, audience, or what
              to avoid.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <LinkIcon size={18} className="text-primary mt-0.5 shrink-0" />
            <span className="text-foreground text-sm">
              Drop <span className="font-medium">links, images, and files</span> you want CASSI to
              learn from.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <SparklesIcon size={18} className="text-primary mt-0.5 shrink-0" />
            <span className="text-foreground text-sm">
              When it feels right, hit <span className="font-medium">Finalize &amp; continue</span>{' '}
              and we'll turn the board into your brand brief.
            </span>
          </li>
        </ul>
        <Button onClick={onDismiss} className="mt-5 w-full" size="sm">
          Got it
        </Button>
      </div>
    </div>
  )
}
